import welcome from '#/assets/welcome2.png';
import {ActionMenuSection} from '#/components/actionmenu/types';
import {ReactComponent as BorrowIcon} from '#/components/icons/ico-borrow.svg';
import {ReactComponent as GraphIcon} from '#/components/icons/ico-graph.svg';
import {ReactComponent as PinIcon} from '#/components/icons/ico-pin.svg';
import {ReactComponent as RightArrowIcon} from '#/components/icons/right-arrow.svg';
import {Layout} from '#/components/layout/layout';
import {Step} from '#/components/welcome-modal/Step';
import {useQueryNavigationActions} from '#/hooks/use-query-navigation-actions';
import {Page} from '#/pages/page';
import {ExchangeRoute} from '#/routes/exchange/exchange-route';
import {Land, UnlistedLand} from '@shareland/shareland-common';
import {useTranslation} from 'react-i18next';
import {useNavigate} from 'react-router';

export const Wiki = () => {
  const {openLandOnMap} = useQueryNavigationActions();
  const {t} = useTranslation('translation');
  const navigate = useNavigate();

  const content = {
    title: t('welcome.investInMarket'),
    src: welcome,
    description: t('welcome.step1Description'),
    contents: [
      {
        Icon: <PinIcon />,
        header: t('welcome.explore'),
        sub: t('welcome.exploreSub'),
      },
      {
        Icon: <BorrowIcon />,
        header: t('welcome.transact'),
        sub: t('welcome.transactSub'),
      },
      {
        Icon: <GraphIcon />,
        header: t('welcome.monitor'),
        sub: t('welcome.monitorSub'),
      },
    ],
  };

  const onSearch = (land: Land | UnlistedLand) => {
    openLandOnMap(land, ActionMenuSection.INFORMATION);
  };

  const handleNavigate = () => {
    navigate(ExchangeRoute.HOME);
  };

  return (
    <Page title={t('pages.landing.howItWorks.title')}>
      <Layout variant='fill' onSearch={onSearch}>
        <div className='w-full'>
          <Step onClick={handleNavigate} {...content} buttonLabel='Explore Markets' RightIcon={RightArrowIcon} />
        </div>
      </Layout>
    </Page>
  );
};
